export enum HubloPoolOnboardingStep {
  WELCOME = 'WELCOME',
  JOBS = 'JOBS',
  SPECIALTIES = 'SPECIALTIES',
  ADDRESS = 'ADDRESS',
  RADIUS = 'RADIUS',
  DOCUMENT = 'DOCUMENT',
  COMPLETED = 'COMPLETED',
}

export enum HubloPoolApplicationStatus {
  NEW = 'NEW',
  PENDING_REVIEW = 'PENDING_REVIEW',
  ACCEPTED = 'ACCEPTED',
  DECLINED = 'DECLINED',
  NONE = 'NONE',
  DISABLED = 'DISABLED',
}

export enum HubloPoolContactStatus {
  NEW = 'NEW',
  CONTACTED = 'CONTACTED',
  MISSING_DOCUMENT = 'MISSING_DOCUMENT',
  NO_REPLY = 'NO_REPLY',
  REFUSED = 'REFUSED',
}

export enum HubloPoolApplicationType {
  JOIN = 'JOIN',
  UPDATE = 'UPDATE',
}
